import { useEffect, useLayoutEffect, useRef } from "react";
import Carrusel from "./Carrusel";
import useData from "./useData";
import WorkItem from "./WorkItem";
import ImageReel from "./ImageReel";
import TecnologiasGrid from "./TecnologiasGrid";
import useIntersectionObserver from "./Intersection";
import SmoothScroll from './SmoothScroll';

const Section = ({ children, className = "" }) => {
  const [ref, isVisible] = useIntersectionObserver();
  return (
    <section ref={ref} className={`${className} ${isVisible ? "show" : ""}`}>
      {children}
    </section>
  );
};

export default function CompTrabajos({ setPagina }) {

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const { proyectos } = useData();

  return (
    <div className="content trabajos">
      <SmoothScroll />

      <Section className="inicio section full-height">

        <div className="box-data acerca">
          <h1>Éstos son mis proyectos</h1>
          <a className="button-big" onClick={() => setPagina("inicio")}>Volver al inicio</a>
        </div>

        <div className="box-data">
          <h4>Para un vistazo rápido</h4>

          <Carrusel items={proyectos} />
        </div>

      </Section>

      <section id="proyecto1">

        <div className="project-content">

          <h1>{proyectos[0].titulo}</h1>
          <TecnologiasGrid mostrar={["Laravel", "PHP", "JQuery", "NodeJS", "Blade", "MySQL", "PhpMyAdmin", "Ubuntu"]} />
          <hr />

          <div className="box-data">
            <h4>Descripción</h4>
            <p>Desarrollado íntegramente con <strong>LARAVEL</strong>, esta plataforma web facilita la gestión integral de reservas de viajes, ofreciendo una experiencia optimizada tanto para clientes como para administradores. Diseñé la interfaz utilizando Figma, elaborando mockups detallados para estructurar la disposición visual y mejorar la experiencia del usuario antes de su implementación.</p>
            <p>El desarrollo se basa en una arquitectura <strong>modular con componentes reutilizables</strong>, lo que garantiza una aplicación altamente escalable, mantenible y fácil de actualizar.</p>
            <p>Actualmente, este proyecto está siendo adaptado para <a href="https://pureimpactjourneys.com/" target="_blank" rel="noopener noreferrer">Pure Impact Journeys</a>, una empresa interesada en su sistema de puntuación de clientes y la gestión avanzada de perfiles de usuario.</p>
          </div>


          <WorkItem
            imagen={"images/works/samples/utopik6.jpg"}
            alt={"utopik project"}
            descripcion={
              <div>
                <h4>Tencologías utlizadas:</h4>
                <p><strong>Backend:</strong> Laravel (PHP), MySQL</p>
                <p><strong>Frontend:</strong> Blade, JavaScript, jQuery</p>
                <p><strong>CMS Personalizado:</strong> Gestión de viajes, usuarios y reservas</p>
                <p><strong>Autenticación y Roles:</strong> Middleware de Laravel</p>
                <p><strong>Gestión de datos:</strong> Eloquent ORM, Query Builder</p>
                <p><strong>Seguridad:</strong> Protección CSRF, Validaciones, Middleware</p>
                <p><strong>Despliegue:</strong> Servidor Apache/Nginx, Ubuntu</p>
              </div>
            }
          />
          <div className="figma">
            <div className="box-data">
              <h4>Diseño en Figma</h4>
            </div>
            <iframe src="https://embed.figma.com/design/ID6z1CNPuf8GOENiRdzBtr/Utopik?node-id=0-1&embed-host=share" allowfullscreen></iframe>
          </div>
          <WorkItem
            imagen={"images/works/samples/utopik1.jpg"}
            descripcion={
              <div>
                <h4>Principales funciones implementadas:</h4>
                <p>CMS a medida para la gestión de viajes, usuarios y reservas.</p>
                <p>Sistema de autenticación y roles con middleware de Laravel.</p>
                <p>Panel de administración con CRUD avanzado y control de permisos.</p>
                <p>Optimización de base de datos y consultas con Eloquent ORM.</p>
                <p>Seguridad reforzada con validaciones, middleware y protección CSRF.</p>
              </div>
            }
            alt={"utopik project"}
          />
          <div className="box-data">
            <h4>Muestras</h4>
          </div>
          <ImageReel imagenes={["images/works/samples/utopik5.jpg", "images/works/samples/utopik3.jpg", "images/works/samples/utopik4.jpg"]} />

          <div className="box-data">
            <h4>Visita la página</h4>
            <p>Esta página está en desarrollo y por el momento <strong>sólo se puede visitar mediante un pin de acceso</strong>.</p>
            <p>Por favor, envíame un mensaje solicitando el acceso para ver la muestra online.</p>
            <a className="button-big" href="https://utopik.sergiosm.es" target="_blank" rel="noopener noreferrer" aria-label="utopik travel">Web Utopik Travel</a>
          </div>
        </div>

      </section>

      <section id="proyecto2">

        <div className="project-content">

          <h1>{proyectos[1].titulo}</h1>
          <TecnologiasGrid mostrar={["Laravel", "PHP", "JQuery", "Blade", "MySQL", "PhpMyAdmin", "Ubuntu"]} />
          <hr />

          <div className="box-data">
            <h4>Descripción</h4>
            <p>Se trata de un proyecto de actualización de la web <a href="https://coloralavida.es/" target="_blank" rel="noopener noreferrer">"Color a la Vida"</a>, una asociación de personas afectadas por el suicidio de un ser querido.</p>
            <p>Esta actualización permitirá a su administrador publicar contenidos audiovisuales a través de un <strong>gestor propio</strong> desarrollado de forma exclusiva para ello.</p>
            <p>Uno de sus puntos importantes es la posibilidad de registro a socios y socias. Este registro les permite colaborar con la asociación mediante donativos y a travésde un gestor para socios, permite que éstos puedan publicar sus propios artículos personales.</p>
            <p>Estos artículos son revisados por un administrador a través de la plataforma, el cual podrá establecer los artículos como online.</p>
            <p>El desarrollo se basa en una <strong>arquitectura modular</strong> con componentes reutilizables, lo que garantiza una aplicación altamente escalable, mantenible y fácil de actualizar.</p>
            <p>Actualmente, este proyecto está siendo adaptado para <a href="https://pureimpactjourneys.com/" target="_blank" rel="noopener noreferrer">Pure Impact Journeys</a>, una empresa interesada en su sistema de puntuación de clientes y la gestión avanzada de perfiles de usuario.</p>
          </div>

          <WorkItem
            imagen={"images/works/samples/color2.jpg"}
            alt={"coloralavida"}
            descripcion={
              <div>
                <h4>Tencologías utlizadas:</h4>
                <p><strong>Backend:</strong> Laravel (PHP), MySQL</p>
                <p><strong>Frontend:</strong> Blade, JavaScript, jQuery</p>
                <p><strong>CMS Personalizado:</strong> Administrador y socios</p>
                <p><strong>Autenticación y Roles:</strong> Middleware de Laravel</p>
                <p><strong>Gestión de datos:</strong> Eloquent ORM, Query Builder</p>
                <p><strong>Seguridad:</strong> Protección CSRF, Validaciones, Middleware</p>
                <p><strong>Despliegue:</strong> Servidor Apache/Nginx, Ubuntu</p>
              </div>
            }
          />

          <WorkItem
            imagen={"images/works/samples/color1.jpg"}
            descripcion={
              <div>
                <h4>Principales funciones implementadas:</h4>
                <p>Panel de administración con CRUD para la gestión de contenido audiovisual.</p>
                <p>CMS a medida para la gestión de artículos de los socios/as.</p>
                <p>Sistema de autenticación y roles con middleware de Laravel.</p>
                <p>Optimización de base de datos y consultas con Eloquent ORM.</p>
                <p>Seguridad reforzada con validaciones, middleware y protección CSRF.</p>
              </div>
            }
            alt={"coloralavida"}
          />

          <div className="box-data">
            <h4>Visita la página</h4>
            <p>Puedes visitar la página en desarrollo, establecida online para la realización de pruebas con algunos socios/as.</p>
            <a className="button-big" href="https://color.sergiosm.es" target="_blank" rel="noopener noreferrer" aria-label="utopik travel">Web Color a la Vida</a>
          </div>

        </div>
      </section>

      <section id="proyecto3">
        <div className="project-content">

          <h1>{proyectos[2].titulo}</h1>
          <TecnologiasGrid mostrar={["PHP", "HTML5", "CSS3", "JavaScript", "MySQL", "Ubuntu"]} />
          <hr />

          <div className="box-data">
            <h4>Descripción</h4>
            <p>Tienda en línea de bicicletas con panel de administración para gestionar productos, sin funcionalidad de compra directa. Incluye gestión de imágenes y optimización de consultas.</p>
          </div>

          <WorkItem
            imagen={"images/works/samples/mekabike.jpg"}
            alt={"mekabike"}
            descripcion={
              <div>
                <h4>Tencologías utlizadas:</h4>
                <p><strong>Frontend:</strong> HTML, CSS, JavaScript (Vanilla JS)</p>
                <p><strong>Backend:</strong> PHP (sin frameworks)</p>
                <p><strong>Base de Datos:</strong> MySQL (gestionada con phpMyAdmin)</p>
                <p><strong>Gestión de imágenes:</strong> Upload y manejo con PHP</p>
                <p><strong>Panel de Administración:</strong> CRUD en PHP para gestionar bicicletas</p>

              </div>
            }
          />

          <WorkItem
            imagen={"images/works/samples/meka2.jpg"}
            descripcion={
              <div>
                <h4>Principales funciones implementadas:</h4>
                <p>Catálogo de bicicletas dinámico con imágenes y descripciones.</p>
                <p>Sistema de administración con CRUD para gestionar bicicletas.</p>
                <p>Subida y gestión de imágenes en PHP.</p>
                <p>Interfaz responsiva con CSS puro.</p>
                <p>Optimización de consultas MySQL para mejorar la carga de datos.</p>
              </div>
            }
            alt={"mekabike"}
          />

          <div className="box-data">
            <h4>Visita la página</h4>
            <a className="button-big" href="https://mekabike.es" target="_blank" rel="noopener noreferrer" aria-label="utopik travel">Web Mekabike</a>
          </div>

        </div>


      </section>

      <section id="proyecto4">

        <div className="project-content">

          <h1>{proyectos[3].titulo}</h1>
          <TecnologiasGrid mostrar={["Android", "Java", "PHP", "MySQL", "PhpMyAdmin", "Ubuntu"]} />
          <hr />
          <div className="box-data">
            <h4>Descripción</h4>
            <p>Aplicación Android que muestra las rutas de autobuses en tiempo real, incluyendo geolocalización y seguimiento mediante Google Maps. Los datos se cargan desde una base de datos MySQL.</p>
          </div>
          <WorkItem
            imagen={"images/works/samples/playstore_takemitu.jpg"}
            alt={"takemitu"}
            descripcion={
              <div>
                <h4>Tencologías utlizadas:</h4>
                <p><strong>Lenguaje:</strong> Java (Android)</p>
                <p><strong>Frameworks y Librerías:</strong> Google Maps API, Retrofit, Volley</p>
                <p><strong>Base de Datos:</strong> MySQL (phpMyAdmin)</p>
                <p><strong>Backend:</strong> PHP (API REST)</p>
                <p><strong>Geolocalización:</strong> Google Maps API, Location Services</p>
                <p><strong>Consumo de datos:</strong> API REST con Volley</p>
                <p><strong>Despliegue:</strong> Play Store</p>

              </div>
            }
          />

          <WorkItem
            imagen={"images/works/samples/takemitu1.jpg"}
            descripcion={
              <div>
                <h4>Principales funciones implementadas:</h4>
                <p>Mapa interactivo con Google Maps API para mostrar la ruta de cada autobús.</p>
                <p>Consulta de horarios y rutas con datos obtenidos de MySQL.</p>
                <p>Consumo de API REST mediante Volley para sincronización de datos.</p>
                <p>Geolocalización en tiempo real.</p>
                <p>Optimización de rendimiento para mejorar la carga y visualización de mapas.</p>
              </div>
            }
            alt={"takemitu"}
          />

          <div className="box-data">
            <h4>Muestras</h4>
          </div>
          <ImageReel imagenes={["images/works/samples/takemitu2.jpg", "images/works/samples/takemitu3.jpg", "images/works/samples/takemitu4.jpg"]} />

          <div className="box-data">
            <h4>Descarga la App en PlayStore</h4>
            <a className="button-big" href="https://play.google.com/store/apps/details?id=com.saraodigital.takemitu" target="_blank" rel="noopener noreferrer" aria-label="utopik travel">App Takemitu</a>
          </div>

          <div className="box-data">
            <h4>Revisa su código</h4>
            <a className="button-big" href="https://github.com/Sergiosm77/takemitu" target="_blank" rel="noopener noreferrer" aria-label="utopik travel">GitHub Takemitu</a>
          </div>

        </div>

      </section>

      <section id="proyecto5">

        <div className="project-content">

          <h1>{proyectos[4].titulo}</h1>
          <TecnologiasGrid mostrar={["Android", "Java", "PHP", "MySQL", "PhpMyAdmin", "Ubuntu"]} />
          <hr />
          <div className="box-data">
            <h4>Descripción</h4>
            <p>Aplicación para ver menús, realizar pedidos y dejar valoraciones en restaurantes. Panel de administración para que los restaurantes gestionen sus menús y fotos.</p>
          </div>

          <WorkItem
            imagen={"images/works/portada_store.jpg"}
            alt={"la karta"}
            descripcion={
              <div>
                <h4>Tencologías utlizadas:</h4>
                <p><strong>Lenguaje:</strong> Java (Android)</p>
                <p><strong>Frameworks y Librerías:</strong> Glide (carga de imágenes), Retrofit/Volley (API REST), Google Maps API</p>
                <p><strong>Base de Datos:</strong> MySQL (gestionada con phpMyAdmin)</p>
                <p><strong>Backend:</strong> PHP (API REST propia para autenticación y gestión de datos)</p>
                <p><strong>Autenticación:</strong> Sistema de login personalizado en PHP (JWT/Sesiones)</p>
                <p><strong>Carga de imágenes:</strong> Glide/Picasso</p>
                <p><strong>Gestión de pedidos y valoraciones:</strong> API REST con MySQL</p>
              </div>
            }
          />

          <WorkItem
            imagen={"images/works/samples/lakarta1.jpg"}
            descripcion={
              <div>
                <h4>Principales funciones implementadas:</h4>
                <p>Mapa interactivo con Google Maps API para mostrar la ruta de cada autobús.</p>
                <p>Consulta de horarios y rutas con datos obtenidos de MySQL.</p>
                <p>Consumo de API REST mediante Volley para sincronización de datos.</p>
                <p>Geolocalización en tiempo real.</p>
                <p>Optimización de rendimiento para mejorar la carga y visualización de mapas.</p>
              </div>
            }
            alt={"lakarta"}
          />
          <ImageReel imagenes={["images/works/samples/lakarta2.jpg", "images/works/samples/lakarta3.jpg", "images/works/samples/lakarta4.jpg"]} />
          <div className="box-data">
            <h4>Visita la página</h4>
            <p>Esta aplicación estuvo en la PlayStore hasta que fué necesaria una actualización del nivel de API, la cual no se llevó a cabo y fué retirada de la plataforma.</p>
            <p>Puedes ver aquí su código:</p>
            <a className="button-big" href="https://github.com/Sergiosm77/lakarta" target="_blank" rel="noopener noreferrer" aria-label="utopik travel">La Karta en GitHub</a>
          </div>
        </div>
      </section>

      <section id="proyecto6">
        <div className="project-content">
          <h1>{proyectos[5].titulo}</h1>
          <TecnologiasGrid mostrar={["PHP", "HTML5", "CSS3", "JavaScript", "MySQL"]} />
          <hr />
          <div className="box-data">
            <h4>Descripción</h4>

            <p>Portafolio de vídeos de bodas. Es una página sencilla para mostrar servicios de vídeo. Esta página se está actualizando en Laravel para añadir un CMS para clientes.</p>
          </div>
          <WorkItem
            imagen={"images/works/saraodigital.jpg"}
            alt={"saraodigital"}
            descripcion={
              <div>
                <h4>Tencologías utlizadas:</h4>
                <p><strong>Frontend:</strong> HTML, CSS, JavaScript (Vanilla JS)</p>
                <p><strong>Backend:</strong> PHP (sin frameworks)</p>
                <p><strong>Base de Datos:</strong> MySQL (gestionada con phpMyAdmin) para la carga de contenidos</p>
              </div>
            }
          />

          <div className="box-data">
            <h4>Visita la web</h4>
            <a className="button-big" href="https://saraodigital.com" target="_blank" rel="noopener noreferrer" aria-label="utopik travel">Web Saraodigital</a>
          </div>

        </div>

      </section>

      <section id="proyecto7">
        <div className="project-content">
          <h1>{proyectos[6].titulo}</h1>
          <TecnologiasGrid mostrar={["React", "JavaScript", "HTML5", "CSS3", "Photoshop"]} />
          <hr />
          <div className="box-data">
            <h4>Descripción</h4>

            <p>La página que estás viendo en estos momentos está desarrollada íntegramente en React.</p>
            <p>He implementado una arquitectura basada en componentes reutilizables (prácticamente todos los elementos son componentes), mejorando la modularidad y mantenibilidad del código. He usado Hooks como "useEffect", "useLayoutEffect" para realizar cálculos y ajustes en la UI antes del renderizado, "useRef" para acceder y manipular elementos del DOM y "useState" para la interactividad en ciertos componentes dinámicos.</p>
            <p>La aplicación sigue buenas prácticas de desarrollo y optimización en React.</p>
          </div>
          <WorkItem
            imagen={"images/works/samples/react.jpg"}
            alt={"react"}
            descripcion={
              <div>
                <h4>Tencologías utlizadas:</h4>
                <p><strong>Frontend:</strong> React.js, CSS (Styled Components), JavaScript (ES6+).</p>
                <p><strong>Gestión de estado y efectos:</strong> React Hooks (useState, useEffect, useLayoutEffect, useRef).</p>
                <p><strong>Multimedia:</strong> API de Audio para el reproductor de música.</p>
                <p><strong>Interactividad y animaciones:</strong> CSS Transitions.</p>
                <p><strong>Componentización:</strong> Diseño modular con componentes reutilizables en React.</p>
              </div>
            }
          />

          <WorkItem
            imagen={"images/works/samples/react1.jpg"}
            descripcion={
              <div>
                <h4>Principales funciones implementadas:</h4>
                <p>Reproductor de música interactivo, con controles de reproducción, pausa y volumen.</p>
                <p>Carrusel de imágenes dinámico, con navegación manual y automática.</p>
                <p>Gestión eficiente del estado con useState y optimización de efectos con useEffect.</p>
                <p>Manipulación del DOM con useRef para mejorar la interactividad.</p>
                <p>Optimización del renderizado, utilizando useLayoutEffect para ajustes previos a la pintura en la pantalla.</p>
                <p>Diseño responsivo y atractivo, utilizando CSS.</p>
              </div>
            }
            alt={"react"}
          />

        </div>

      </section>

      <section className="contacto">
        <div className="box-data">
          <h1>¿Hablamos?</h1>
        </div>
        <a className="button-big" onClick={() => setPagina("contacto")}>Contáctame</a>
      </section>

    </div>
  );
}
